<template>
    <div class="uik-data-widget">
        <div v-if="title" class="uik-data-widget__title">{{ title }}</div>
        <div class="uik-data-widget__content">
            <slot/>
        </div>
    </div>
</template>

<script>
export default {
    name: "UikDataWidget",
    props: {
        /**
         * Title displayed above content
         */
        title: { type: String, default: "" }
    }
}
</script>

<style lang="scss">
.uik-data-widget {
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 15px -10px rgba($textMain, 0.3),  0 10px 20px -10px rgba($textBase, 0.15);
  padding: 25px 28px;

  .uik-data-widget__title {
    font-size: 17px;
    font-weight: 500;
    color: $textMain;
    margin-bottom: 20px;
  }

  // Table

  .uik-table {
    padding: 0;
    margin: -5px;
    width: calc(100% + 10px);

    .uik-table__wrapper {
      max-width: unset;
      border-radius: 0;
      box-shadow: none;
      border: none;
      background: transparent;

      .uik-table__container {
        border-radius: 0;
      }
    }
  }

  .uik-table-head-cell {
    .uik-table-head-cell__container {
      padding: 5px 10px;
      height: 30px;
      border-bottom: none;
      font-size: 11px;
      text-transform: uppercase;
      color: rgba($textBase, 0.45);
      font-weight: 700;
      letter-spacing: 0.5px;
    }
  }

  .uik-table-row {
    transition: none;

    &:hover {
      background: darken($bg, 2%);
    }

    & + .uik-table-row {
      border-top: none;
    }
  }

  .uik-table-cell {
    .uik-table-cell__container {
      .uik-table-cell__content {
        min-height: unset;
        padding: 5px 10px;
        font-size: 13px;
        font-weight: 500;
        line-height: 16px;

        &.uik-table-cell__text {
          &--small {
            font-size: 10px;
            line-height: 14px;
          }

          &--bold {
            font-weight: 600;
          }
        }
      }
    }
  }
}
</style>
